/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_TocInputs */

const en_pc_tut_toc = /** @type {(inputs: Pc_Tut_TocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons`)
};

const zh_pc_tut_toc = /** @type {(inputs: Pc_Tut_TocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程目录`)
};

/**
* | output |
* | --- |
* | "Lessons" |
*
* @param {Pc_Tut_TocInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_toc = /** @type {((inputs?: Pc_Tut_TocInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_TocInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_toc(inputs)
	return zh_pc_tut_toc(inputs)
});
export { pc_tut_toc as "pc.tut.toc" }